import React, { Component } from 'react';
import styled from 'styled-components';
import ContactModal from '../../../components/ContactModal';

const ModernCTASection = styled.section`
  position: relative;
  z-index: 1;
  
  .cta-content {
    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      margin-bottom: 1.5rem;
    }
    
    .btn-custom-white {
      background: #ffffff;
      color: #51c2c9;
      border: none;
      padding: 0.85rem 2.5rem;
      border-radius: 8px;
      font-weight: 600;
      transition: all 0.3s ease;
      text-decoration: none;
      display: inline-block;
      cursor: pointer;
      position: relative;
      z-index: 10;
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 20px rgba(255, 255, 255, 0.3);
        color: #51c2c9;
        text-decoration: none;
      }
      
      &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(81, 194, 201, 0.3);
      }
      
      i {
        margin-left: 0.5rem;
        transition: transform 0.3s ease;
      }
      
      &:hover i {
        transform: translateX(5px);
      }
    }
  }
`;

class Cta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            freeTrialModal: false,
        };
        this.toggleFreeTrialModal = this.toggleFreeTrialModal.bind(this);
    }

    toggleFreeTrialModal() {
        this.setState(prevState => ({
            freeTrialModal: !prevState.freeTrialModal
        }));
    }

    render() {
        return (
            <React.Fragment>
                <ContactModal show={this.state.freeTrialModal} onHide={this.toggleFreeTrialModal} />
                
                <ModernCTASection className="section cta-bg">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="cta-content text-center text-white">
                                    <h3 className="mb-4">Experience the Future of Geospatial Intelligence</h3>
                                    <p className="text-light f-16">Sign up for a free 30-day trial and discover what AI-powered analysis can reveal about your geospatial data.</p>
                                    <div className="pt-3">
                                        <button onClick={this.toggleFreeTrialModal} className="btn btn-custom-white">START FREE TRIAL <i className="mdi mdi-arrow-right"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModernCTASection>
            </React.Fragment>
        );
    }
}

export default Cta;
